import * as React from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export function DisabledWithTooltip({
  disabled,
  reason,
  children,
}: {
  disabled: boolean
  reason?: React.ReactNode
  children: React.ReactElement
}) {
  if (!disabled) return children

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* IMPORTANT: wrapper pour capter hover quand child est disabled */}
        <span className='inline-flex cursor-not-allowed'>{children}</span>
      </TooltipTrigger>
      <TooltipContent>
        <div className='max-w-[240px] text-xs'>
          {reason ?? 'Action indisponible'}
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
